export const PROJECT_LIFECYCLE = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    CLOSED: 'closed',
    ARCHIVED: 'archived',
};

export const PROJECT_LIFECYCLE_LABEL = {
    [PROJECT_LIFECYCLE.DRAFT]: 'Draft',
    [PROJECT_LIFECYCLE.PUBLISHED]: 'Published',
    [PROJECT_LIFECYCLE.CLOSED]: 'Closed',
    [PROJECT_LIFECYCLE.ARCHIVED]: 'Archived',
};

export function normalizeProjectLifecycleStatus(value) {
    switch (value) {
    case PROJECT_LIFECYCLE.PUBLISHED:
    case PROJECT_LIFECYCLE.CLOSED:
    case PROJECT_LIFECYCLE.ARCHIVED:
        return value;
    case PROJECT_LIFECYCLE.DRAFT:
    default:
        return PROJECT_LIFECYCLE.DRAFT;
    }
}

export function isParticipantVisibleLifecycle(status) {
    return status === PROJECT_LIFECYCLE.PUBLISHED || status === PROJECT_LIFECYCLE.CLOSED;
}

export function isParticipantActiveLifecycle(status) {
    return status === PROJECT_LIFECYCLE.PUBLISHED;
}

export function getLifecycleStatusChipClass(status, styles) {
    switch (status) {
    case PROJECT_LIFECYCLE.PUBLISHED:
        return styles.hubProjectStatusPublished;
    case PROJECT_LIFECYCLE.CLOSED:
        return styles.hubProjectStatusClosed;
    case PROJECT_LIFECYCLE.ARCHIVED:
        return styles.hubProjectStatusArchived;
    case PROJECT_LIFECYCLE.DRAFT:
    default:
        return styles.hubProjectStatusDraft;
    }
}

export function getLifecycleStatusTitle(status) {
    switch (status) {
    case PROJECT_LIFECYCLE.PUBLISHED:
        return 'Published — visible to assigned participants.';
    case PROJECT_LIFECYCLE.CLOSED:
        return 'Closed — visible to participants, but annotation access is disabled.';
    case PROJECT_LIFECYCLE.ARCHIVED:
        return 'Archived — hidden from participant My projects and annotation access disabled.';
    case PROJECT_LIFECYCLE.DRAFT:
    default:
        return 'Draft — only project admins can access this project.';
    }
}
